import React from 'react';
import styles from './VolumeControls.module.scss';
import Icon from '../../../../components/Icon/Icon';
import Slider from 'rc-slider';

const VolumeControls = ({ type = 'video', value, onChange, maxVolume }) => {
    return <div className={styles.sliderContainer}>
        <div className={styles.volumeValueContainer}>
            <Icon
                onClick={() => onChange(value === 0 ? 100 : 0)}
                src={value === 0 ? type == 'video' ? 'noVideoVolume' : 'noMusicVolume' : type == 'video' ? 'videoVolume' : 'musicVolume'}
                className={styles.icon}
                verticalAlign="middle"
            />
            <span className={styles.volumeValue}>{Math.round(value * 100)}</span>
        </div>
        <Slider
            min={0}
            max={Number.isInteger(maxVolume) ? maxVolume : 100}
            step={1}
            onChange={onChange}
            value={value * 100}
            included
            style={{ width: '160px', paddingRight: '8px', zIndex: 100 }}
            handleStyle={{
                width: '18px',
                height: '18px',
                background: '#7C43AA',
                position: 'relative',
                top: '-10px',
                borderRadius: '9px',
                boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.1)',
                cursor: 'pointer',
            }}
            trackStyle={{
                background: '#7C43AA',
                height: '4px',
                borderRadius: '2px',
                position: 'relative',
                top: '-4px',
            }}
            railStyle={{
                background: '#EEEEEE',
                height: '4px',
                borderRadius: '2px',
                position: 'relative',
            }}
        />
    </div>
}

export default VolumeControls;